var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBedFrontRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "85px",
    height: "66px",
    viewBox: "0 0 85 66",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "55C697B5-81E0-4799-9D6A-571763E9B537") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zenvoya-JULY-2024",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MY-TRIPS---HOTEL-Summary",
    transform: "translate(-737.000000, -778.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cancel-options-group",
    transform: "translate(454.000000, 781.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bed-front-red",
    transform: "translate(286.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bed-front-light",
    transform: "translate(3.950000, 3.947368)",
    fill: "#BF150D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.9,7.89473684 L7.9,12.9029605 C9.0603125,12.2368421 10.4057812,11.8421053 11.85,11.8421053 L25.675,11.8421053 C28.0326562,11.8421053 30.1557812,12.8782895 31.6,14.5189145 C33.0442187,12.8782895 35.1673437,11.8421053 37.525,11.8421053 L51.35,11.8421053 C52.7942187,11.8421053 54.1396875,12.2245066 55.3,12.9029605 L55.3,7.89473684 C55.3,5.71134868 53.5348437,3.94736842 51.35,3.94736842 L11.85,3.94736842 C9.66515625,3.94736842 7.9,5.71134868 7.9,7.89473684 Z M59.25,19.7368421 L59.25,25.6578947 C61.6446875,27.4588816 63.2,30.3207237 63.2,33.5526316 L63.2,45.3947368 L63.2,53.2894737 C63.2,54.375 62.31125,55.2631579 61.225,55.2631579 C60.13875,55.2631579 59.25,54.375 59.25,53.2894737 L59.25,47.3684211 L3.95,47.3684211 L3.95,53.2894737 C3.95,54.375 3.06125,55.2631579 1.975,55.2631579 C0.88875,55.2631579 0,54.375 0,53.2894737 L0,45.3947368 L0,33.5526316 C0,30.3207237 1.5553125,27.4588816 3.95,25.6578947 L3.95,19.7368421 L3.95,7.89473684 C3.95,3.54029605 7.49265625,0 11.85,0 L51.35,0 C55.7073437,0 59.25,3.54029605 59.25,7.89473684 L59.25,19.7368421 Z M55.3,23.8815789 L55.3,19.7368421 C55.3,17.5534539 53.5348437,15.7894737 51.35,15.7894737 L37.525,15.7894737 C35.3401562,15.7894737 33.575,17.5534539 33.575,19.7368421 L33.575,23.6842105 L53.325,23.6842105 C54.0039062,23.6842105 54.658125,23.7582237 55.3,23.8815789 Z M29.625,23.6842105 L29.625,19.7368421 C29.625,17.5534539 27.8598437,15.7894737 25.675,15.7894737 L11.85,15.7894737 C9.66515625,15.7894737 7.9,17.5534539 7.9,19.7368421 L7.9,23.8815789 C8.541875,23.7582237 9.19609375,23.6842105 9.875,23.6842105 L29.625,23.6842105 Z M59.25,33.5526316 C59.25,30.2837171 56.5960937,27.6315789 53.325,27.6315789 L9.875,27.6315789 C6.60390625,27.6315789 3.95,30.2837171 3.95,33.5526316 L3.95,43.4210526 L59.25,43.4210526 L59.25,33.5526316 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 0.395,
    y1: 5.92105263,
    x2: 73.865,
    y2: 59.6052632,
    id: "Line-3-Copy",
    stroke: "#FFFFFF",
    strokeWidth: 3.94736842,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.135,
    y1: 0.394736842,
    x2: 78.605,
    y2: 54.0789474,
    id: "Line-3-Copy-2",
    stroke: "#FFFFFF",
    strokeWidth: 3.94736842,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.975,
    y1: 2.76315789,
    x2: 75.445,
    y2: 56.4473684,
    id: "Line-3",
    stroke: "#BF150D",
    strokeWidth: 3.94736842,
    strokeLinecap: "square"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedFrontRed);
export default __webpack_public_path__ + "static/media/bed-front-red.71423367a7e86ce769814acdd37a5c3f.svg";
export { ForwardRef as ReactComponent };